// extracted by mini-css-extract-plugin
module.exports = {"ProductDetailJumpers":"ProductNavigation_ProductDetailJumpers__QJcgs"};